export const FETCH_VISITS_ROASTER = "[RECEPTIONIST] FETCH_VISITS_ROASTER";
export const FETCH_VISITS_ROASTER_START = "[RECEPTIONIST] FETCH_VISITS_ROASTER_START";
export const FETCH_VISITS_ROASTER_SUCCESS = "[RECEPTIONIST] FETCH_VISITS_ROASTER_SUCCESS";
export const FETCH_VISITS_ROASTER_ERROR = "[RECEPTIONIST] FETCH_VISITS_ROASTER_ERROR";

export const CANCEL_APPOINTMENT_EVENT = "[RECEPTIONIST] CANCEL_APPOINTMENT_EVENT";
export const CANCEL_APPOINTMENT_EVENT_START = "[RECEPTIONIST] CANCEL_APPOINTMENT_EVENT_START";
export const CANCEL_APPOINTMENT_EVENT_SUCCESS = "[RECEPTIONIST] CANCEL_APPOINTMENT_EVENT_SUCCESS";
export const CANCEL_APPOINTMENT_EVENT_ERROR = "[RECEPTIONIST] CANCEL_APPOINTMENT_EVENT_ERROR";

export const UNDO_VISIT = "[RECEPTIONIST] UNDO_VISIT";
export const UNDO_VISIT_SUCCESS = "[RECEPTIONIST] UNDO_VISIT_SUCCESS";
export const UNDO_VISIT_ERROR = "[RECEPTIONIST] UNDO_VISIT_ERROR";

export const fetchVisitsRoaster = (data) => {
    //console.log("fetchVisitsRoaster payload:", data);
    return {
        type: FETCH_VISITS_ROASTER,
        payload: data
    }
}

export const cancelVisitAppointmentEvent = (appointmentId, eventId) => {
    return {
        type: CANCEL_APPOINTMENT_EVENT,
        payload: { appointmentId, eventId }
    }
}

export const undoVisit = (payload) => {
    return {
        type: UNDO_VISIT,
        payload
    }
}